import {useContext, useEffect} from 'react';

import i18n from '@/i18n';
import api from '@/api';
import {userCtx, userDispatchCtx} from '@/auth';
import {appHost, appBaseName} from '@/config';
import {SystemConfigCtx} from '@/contexts';

const Logout = () => {
  const user = useContext(userCtx);
  const dispatch = useContext(userDispatchCtx);
  const lang = i18n.language;
  const {siteCode} = useContext(SystemConfigCtx);

  useEffect(() => {
    api
      .delete('/logout')
      .then(res => dispatch({type: 'me', payload: res.data}));
  }, []);

  if (user.currentProducer || user.currentClient) {
    return null;
  }

  const returnPath = {
    afs: `${appHost}/${lang}`,
    ipc: `${appHost}/${lang}`,
    absg: `${appHost}${appBaseName}`,
  };

  window.location.href = returnPath[siteCode];
  return null;
};

export default Logout;
